import React, { useState } from 'react'
import {
  Grid,
  Card,
  Box,
  Typography,
  makeStyles,
  Checkbox,
  Button,
  CardMedia,
  IconButton,
  Stack,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ImageListItem,
  ImageListItemBar,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import EditIcon from '@material-ui/icons/Edit'
import { useTheme } from '@material-ui/core/styles'
import { Description, PictureAsPdf } from '@material-ui/icons'
import axios from 'axios'
import { REST_API_END_POINT, REST_API } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'
import { Icon } from '@iconify/react'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined'
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined'
import Modal from './ProjectModel'
import Label from 'src/components/Label'
import moment from 'moment'
import jsPDF from 'jspdf'
import PDFEditor from 'src/components/_dashboard/official-request/PDFEditor'
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton'
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton'
import AttachmentPreviewDialog from 'src/components/_dashboard/official-request/AttachmentPreviewDialog'
import { getFileExtension, isOfficeFile as isOfficeAttachment } from 'src/Helpers/FileDownloadUtils'

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
    cursor: 'pointer',
    display: 'flex',
    borderRadius: '6px',
    backgroundColor: '#172e34',
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    height: '143px',
    overflow: 'hidden',
  },
  attachmentIcon: {
    marginRight: theme.spacing(1),
  },
  delete: {
    m: 2,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  checkbox: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  checkboxContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  approvedContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(3),
    maxWidth: 768,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  //   gridContainer: {
  //     height: 'auto',
  //   },
  card: {
    borderRadius: theme.spacing(1),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    cursor: 'pointer',
  },
  media: {
    height: 0,
    paddingTop: '100%',
    width: '100%',
    objectFit: 'fill',
  },
  gridContainer: {
    height: 'auto',
    overflowY: 'auto',
    paddingRight: '0.5rem',
    '&::-webkit-scrollbar': {
      width: '0.75rem',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(110, 108, 108, 0.32)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(110, 108, 108, 0.32)',
      borderRadius: '4px',
    },
  },
}))

export default function DesignProjectFileAttach({
  details,
  data,
  setFetchData,
  refresh,
  setRefresh,
  setParentRefresh,
  projectId,
  designOrder,
  secTab,
  isAllAttachments,
  isRefer
}) {
  console.log('detailsdetailsdetails',details)
  const classes = useStyles()
  const theme = useTheme()
  let user = JSON.parse(localStorage.getItem('user'))
  const isClient = user?.isClient
  const userType = isClient ? 3 : user?.user_type
  const canDownloadFiles = !isClient && userType !== 3
  const explodedPermissions = user?.exploded_permissions
  const { enqueueSnackbar } = useSnackbar()
  const [open, setOpen] = useState(false)
  const [selectedAttachment, setSelectedAttachment] = useState(null)
  const [pdfLoading, setPdfLoading] = useState(true)
  const [useOfficeViewer, setUseOfficeViewer] = useState(true)
  const [checkedItems, setCheckedItems] = useState([])
  const [openImageModal, setOpenImageModal] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(null)
  const [openPDFEditor, setOpenPDFEditor] = useState(false)
  const [selectedPDFForEdit, setSelectedPDFForEdit] = useState(null)

  const handleCheckboxChange = (id) => {
    setCheckedItems((prevState) => {
      const isPresent = prevState.includes(id)
      const updatedState = isPresent
        ? prevState.filter((item) => item !== id)
        : [...prevState, id]
      return updatedState
    })
  }

  //   const handleUpdateDesign = () => {

  //     const data = { id: id, status: 0, num: 4 }
  //     axios
  //       .post(`${REST_API_END_POINT}request/update-designs`, data)
  //       .then((res) => {
  //       })
  //   }
  const handleDelete = async () => {
    try {
      let apiUrl = ''
      if (designOrder) {
        apiUrl = `design-order-job/delete-attachment`
      } else {
        apiUrl = `project-task/delete-project-attachment`
      }
      const res = await axios.post(`${REST_API_END_POINT}${apiUrl}`, {
        // const res = await axios.post(`${REST_API_END_POINT}project-task/delete-project-attachment`,{
        userId: user.user_id,
        attachments: checkedItems,
        projectId,
      })
      if (res.data.status === 1) {
        const attachmentsToUpdate = data.filter(
          (attachment) =>
            checkedItems.includes(attachment.ID) &&
            attachment.not_approved_image === 1,
        )

        if (attachmentsToUpdate.length > 0) {
          const updatePromises = attachmentsToUpdate.map((attachment) =>
            axios.post(`${REST_API_END_POINT}request/update-designs`, {
              requestId: attachment.request_id,
              userId: user.user_id,
              id: attachment.ID,
              status: 0,
              num: 4,
            }),
          )

          // Wait for all updates to complete
          await Promise.all(updatePromises)
        }
        enqueueSnackbar(res.data.message, { variant: 'success' })
        setRefresh(true)
        setParentRefresh(true)
        setCheckedItems([])
        if (designOrder) {
          setFetchData(true)
        }
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const attachmentToFile = (attachment) =>
    attachment
      ? {
          ...attachment,
          url: attachment.file_url || attachment.url || attachment.name,
          file_type: attachment.file_type,
          name: attachment.name,
        }
      : null

  const handleAttachmentClick = (attachment) => {
    setPdfLoading(true)
    setSelectedAttachment(attachment)
    setOpen(true)
    setUseOfficeViewer(true)
  }
  const imageDesigns = data?.filter(
    (item) =>
      item.file_type?.startsWith('image/') ||
      item.file_type === 'img' ||
      item.file_type === 'image',
  )

  // Define valid image extensions
  const imageExtensions = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'avif',
    'bmp',
    'tiff',
    'webp',
    'heif',
    // "other"
  ]
  const videoExtensions = ['mp4', 'avi', 'mkv', 'mov', 'wmv']
  const documentExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt']

  const handleImageClick = (index) => {
    setCurrentImageIndex(index)
    setOpenImageModal(true)
  }

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : prevIndex,
    )
  }

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex,
    )
  }

  const handleDownloadEditedPdf = async (attachmentId) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-attachment-images`,
        { attachmentId, documentSource: 'design_order' }
      )
      const images = res.data?.images
      if (!images || !images.length) {
        enqueueSnackbar('No edited pages available to download', { variant: 'error' })
        return
      }
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' })
      const pdfPageWidth = pdf.internal.pageSize.getWidth()
      const pdfPageHeight = pdf.internal.pageSize.getHeight()
      const baseUrl = REST_API.endsWith('/') ? REST_API : `${REST_API}/`
      for (let i = 0; i < images.length; i++) {
        const image = images[i]
        const imagePath = (image.image_url || '').startsWith('/') ? image.image_url.slice(1) : image.image_url
        const imageUrl = (imagePath || '').startsWith('uploads') ? `${baseUrl}${imagePath}` : `${baseUrl}uploads/${imagePath}`
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.src = imageUrl
        await new Promise((resolve, reject) => {
          img.onload = resolve
          img.onerror = () => reject(new Error(`Failed to load image: ${imageUrl}`))
        })
        const scale = 4
        const aspectRatio = img.height / img.width
        const renderWidth = pdfPageWidth
        const renderHeight = renderWidth * aspectRatio
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = renderWidth * scale
        canvas.height = renderHeight * scale
        ctx.scale(scale, scale)
        ctx.imageSmoothingEnabled = true
        ctx.imageSmoothingQuality = 'high'
        ctx.drawImage(img, 0, 0, renderWidth, renderHeight)
        const imgData = canvas.toDataURL('image/png', 1.0)
        if (i !== 0) pdf.addPage()
        const calculatedHeight = pdfPageWidth * aspectRatio
        const finalHeight = calculatedHeight > pdfPageHeight ? pdfPageHeight : calculatedHeight
        const finalWidth = finalHeight / aspectRatio
        pdf.addImage(imgData, 'PNG', 0, 0, finalWidth, finalHeight, undefined, 'FAST')
      }
      pdf.save('edited_document.pdf')
      enqueueSnackbar('PDF downloaded successfully', { variant: 'success' })
    } catch (error) {
      console.error('Failed to download edited PDF', error)
      enqueueSnackbar(error?.message || 'Unable to download edited PDF', { variant: 'error' })
    }
  }
  console.log('return======data', data)
  return (
    <>
      {checkedItems.length > 0 && (
        <Box
          sx={{
            mb: 3,
            position:'absolute',
            top:3,
            right:3,
            display: 'flex',
            alignItems:'center',
            justifyContent: 'flex-end',
            gap: 2,
            m: 2.5,
          }}
        >
          <Typography variant="subtitle1">
            {checkedItems.length} selected
          </Typography>
          <Button
            disabled={
              designOrder
                ? !explodedPermissions?.some((permission) =>
                    ['Delete Design from Design Order Job'].includes(
                      permission,
                    ),
                  )
                : false
            }
            onClick={() => handleDelete()}
            className={classes.delete}
            size="small"
            variant="outlined"
            sx={{
              alignItems:'center',
              justifyContent: 'center',
            }}
          >
            <Icon icon={trash2Outline} width={24} height={24} /> Delete
          </Button>
        </Box>
      )}

      {data?.length > 0 ? (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mb: 2,
              px: 1,
            }}
          >
            <AttachmentDownloadAllButton
              files={(data || [])
                .filter((item) => checkedItems.includes(item.ID))
                .map((item) => attachmentToFile(item))
                .filter(Boolean)}
              allFiles={(data || []).map((item) => attachmentToFile(item)).filter(Boolean)}
              onToggleSelectAll={(checked) => {
                if (checked) {
                  setCheckedItems((data || []).map((item) => item.ID).filter(Boolean))
                } else {
                  setCheckedItems([])
                }
              }}
              label="Download Selected"
              hidden={!canDownloadFiles}
              size="small"
            />
          </Box>
        <Grid className={classes.gridContainer} container spacing={3} pb={4}>
          {data?.map((attachment, index) => {
            const fileType = attachment.file_type?.toLowerCase() // Normalize case
            const fileExtension = (
              attachment.extension?.toLowerCase() ||
              getFileExtension(attachment.file_url || attachment.name) ||
              ''
            )
            const isGoogleFormat = ['eps','ai', 'ps', 'psd','tif','tiff','indd','indt'].includes(fileExtension);

            const isImage = (
              fileType?.startsWith('image/') ||
              fileType === 'img' ||
              fileType === 'image' ||
              imageExtensions.includes(fileExtension)
            ) && !isGoogleFormat;

            const isPdf = fileExtension === 'pdf' || fileType === 'application/pdf';
            const isOfficeFile =
              isOfficeAttachment(attachment.file_url || attachment.name, attachment.file_type) ||
              ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExtension);

            const isDocument =
              isPdf ||
              documentExtensions.includes(fileExtension) ||
              fileType?.includes('document') ||
              isGoogleFormat ||
              isOfficeFile;
            
            console.log('isDocument', isDocument)
            return (
              <Grid key={attachment.id} item xs={12} sm={4} sx={{ mb: 4 }}>
                {isImage ? (
                  <Card className={classes.card} sx={{ position: 'relative' }}>
                    <AttachmentDownloadIconButton
                      file={attachmentToFile(attachment)}
                      fileIndex={index}
                      hidden={!canDownloadFiles}
                      sx={{ position: 'absolute', top: 8, left: 8, zIndex: 12 }}
                    />
                    {/* <Box className={classes.approvedContainer}>
                      {attachment.approved === 1 ?(
                        <Label
                          variant={'filled'}
                          color={'success'}
                          style={{ color: 'white', height: 20, width: 100 }}
                        >
                          {'Approved'}
                        </Label>                       
                      ): 
                      attachment.reason ? (
                        <Tooltip title={attachment.reason}>
                          <Label
                            variant={'filled'}
                            color={'error'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Rejected'}
                          </Label>
                        </Tooltip>
                      ):null}
                    </Box> */}
                    <CardMedia
                      className={classes.media}
                      image={attachment.file_url}
                      title={`Image ${attachment.file_url}`}
                      onClick={(e) => {
                        e.preventDefault()
                        handleImageClick(
                          imageDesigns.findIndex(
                            (img) => img.file_url === attachment.file_url,
                          ),
                        )
                      }}
                    />
                    {/* {isAllAttachments || (details?.send_client_app_req == 1 && attachment?.isDesign == 1) || attachment?.approved == 1 ? ( */}
                    {isRefer || isAllAttachments || (details?.send_client_app_req == 1 && attachment?.isDesign == 1) ? (
                      ''
                    ) : (
                      <Box className={classes.checkboxContainer}>
                        <Checkbox
                          sx={{
                            cursor: 'pointer',
                            // color: 'primary',
                            backgroundColor: theme.palette.grey.A700
                          }}
                          checked={
                            checkedItems.includes(attachment.ID) ? true : false
                          }
                          onChange={() => handleCheckboxChange(attachment.ID)}
                          color="primary"
                        />
                      </Box>
                    )}
                  </Card>
                ) : isDocument ? (
                  designOrder ? (
                    <Box
                      sx={{
                        width: '100%',
                        maxWidth: 240,
                        mx: 'auto',
                        overflow: 'hidden',
                        position: 'relative',
                        listStyle: 'none',
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          display: 'block',
                          width: 240,
                          height: 240,
                          position: 'relative',
                          cursor: 'pointer',
                          borderRadius: 1.5,
                          overflow: 'hidden',
                          backgroundColor: '#f5f5f5',
                          border: '1px solid #e0e0e0',
                        }}
                        onClick={() => handleAttachmentClick(attachment)}
                      >
                        <AttachmentDownloadIconButton
                          file={attachmentToFile(attachment)}
                          fileIndex={index}
                          hidden={!canDownloadFiles}
                          sx={{ position: 'absolute', top: 8, left: 8, zIndex: 12 }}
                        />
                        {(() => {
                          const fileName = attachment.file_url?.split('/').pop()?.split('?')[0] || attachment.name || 'File';
                          const fileExt = fileName.split('.').pop()?.toLowerCase();
                          const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                          const isGoogleFile = ['ai', 'eps', 'ps', 'psd', 'tif', 'tiff', 'indd', 'indt'].includes(fileExt);
                          
                          
                          return (
                            <>
                              <Tooltip title={isPdf ? "View PDF" : isGoogleFormat ? "View Design" : "View File"}>
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleAttachmentClick(attachment)
                                  }}
                                  aria-label="open file"
                                  sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 200,
                                    color: theme.palette.error.main,
                                    backgroundColor: theme.palette.text.primary,
                                  }}
                                >
                                  {isOfficeFile ? (
                                    <Description style={{ fontSize: 50, color: 'green' }} />
                                  ) : isPdf ? (
                                    <PictureAsPdf style={{ fontSize: 50, color: 'red' }} />
                                  ) : isGoogleFormat ? (
                                    <Description style={{ fontSize: 50, color: 'blue' }} />
                                  ) : (
                                    <Description style={{ fontSize: 50, color: 'grey' }} />
                                  )}
                                </IconButton>
                              </Tooltip>
                              {isOfficeFile ? (
                                <iframe
                                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(attachment.file_url)}`}
                                  title={fileName}
                                  style={{ width: 240, height: 240, border: 0, borderRadius: 6 }}
                                />
                              ) : isGoogleFile ? (
                                <iframe
                                  src={`https://docs.google.com/gview?url=${encodeURIComponent(attachment.file_url)}&embedded=true`}
                                  title={attachment.name}
                                  style={{ width: 240, height: 240, border: 0, borderRadius: 6 }}
                                 sandbox="allow-scripts allow-same-origin" />
                              ) : (
                                <iframe
                                  src={attachment.file_url}
                                  title={attachment.name}
                                  style={{ width: 240, height: 240, border: 0, borderRadius: 6 }}
                                />
                              )}
                            </>
                          );
                        })()}
                      </Box>
                      <ImageListItemBar
                        sx={{ width: '100%' }}
                        subtitle={
                          <Stack spacing={0.5}>
                            <Typography variant="caption">
                              {attachment.timestamp
                                ? moment.unix(attachment.timestamp).format('MM/DD/YYYY')
                                : ''}
                            </Typography>
                            {isPdf && (
                            <Accordion
                              square
                              disableGutters
                              elevation={0}
                              sx={{
                                backgroundColor: 'transparent',
                                '&:before': { display: 'none' },
                                minHeight: '18px',
                              }}
                            >
                              <AccordionSummary
                                expandIcon={
                                  <ExpandMoreIcon sx={{ fontSize: 18, color: 'inherit' }} />
                                }
                                sx={{
                                  minHeight: '18px',
                                  px: 0,
                                  '&.Mui-expanded': { minHeight: '18px' },
                                  '& .MuiAccordionSummary-content': { margin: 0 },
                                  '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
                                }}
                              >
                                <Typography variant="caption">{isPdf ? 'Edit PDF' : 'Edit File'}</Typography>
                              </AccordionSummary>
                              <AccordionDetails sx={{ p: 0, pt: 1, pb: 0.5 }}>
                                <Stack direction="row" width="100%" spacing={1} sx={{ flexDirection: 'row' }}>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={() => {
                                      setSelectedPDFForEdit({
                                        url: attachment.file_url,
                                        item: attachment,
                                      })
                                      setOpenPDFEditor(true)
                                    }}
                                    startIcon={<EditIcon sx={{ fontSize: 11 }} />}
                                    sx={{
                                      textTransform: 'none',
                                      boxShadow: 'none',
                                      fontSize: '11px',
                                    }}
                                  >
                                    Edit
                                  </Button>
                                  {/* <Button
                                    size="small"
                                    variant="outlined"
                                    color="inherit"
                                    onClick={() =>
                                      handleDownloadEditedPdf(attachment.id || attachment.ID)
                                    }
                                    sx={{ textTransform: 'none', fontSize: '11px' }}
                                  >
                                    Download Edited PDF
                                  </Button> */}
                                </Stack>
                              </AccordionDetails>
                            </Accordion>
                            )}
                          </Stack>
                        }
                      />
                      {!isRefer &&
                        !isAllAttachments &&
                        (details?.send_client_app_req != 1 || attachment?.isDesign != 1) && (
                          <Box className={classes.checkboxContainer}>
                            <Checkbox
                              sx={{
                                cursor: 'pointer',
                                backgroundColor: theme.palette.grey.A700,
                              }}
                              checked={checkedItems.includes(attachment.ID)}
                              onChange={() => handleCheckboxChange(attachment.ID)}
                              color="primary"
                            />
                          </Box>
                        )}
                    </Box>
                  ) : (
                  <Box
                    className={classes.attachmentBox}
                    display="flex"
                    alignItems="center"
                    sx={{ position: 'relative' }}
                  >
                    <AttachmentDownloadIconButton
                      file={attachmentToFile(attachment)}
                      fileIndex={index}
                      hidden={!canDownloadFiles}
                      sx={{ position: 'absolute', top: 8, left: 8, zIndex: 12 }}
                    />
                    {/* <Box className={classes.approvedContainer}>
                      {attachment.approved === 1 ?(
                        <Label
                          variant={'filled'}
                          color={'success'}
                          style={{ color: 'white', height: 20, width: 100 }}
                        >
                          {'Approved'}
                        </Label>                       
                      ): 
                      attachment.reason ? (
                        <Tooltip title={attachment.reason}>
                          <Label
                            variant={'filled'}
                            color={'error'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Rejected'}
                          </Label>
                        </Tooltip>
                      ):null}
                    </Box> */}
                    <Box
                      onClick={() => handleAttachmentClick(attachment)}
                      style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {attachment?.not_approved_image === 1 ? (
                        <img
                          src={attachment.file_url}
                          alt={attachment.name}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: 4,
                          }}
                        />
                      ) : (() => {
                        const fileName = attachment.file_url?.split('/').pop()?.split('?')[0] || attachment.name || 'File';
                        const fileExt = fileName.split('.').pop()?.toLowerCase();
                        const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                        const isGoogleFile = ['ai', 'eps', 'ps', 'psd', 'tif', 'tiff', 'indd', 'indt'].includes(fileExt);
                        
                        
                        return (
                          <>
                            <Tooltip title={isPdf ? "View PDF" : isGoogleFormat ? "View Design" : "View File"}>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAttachmentClick(attachment);
                                }}
                                aria-label="open file"
                                sx={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  zIndex: 200,
                                  color: theme.palette.error.main,
                                  backgroundColor: theme.palette.text.primary,
                                }}
                              >
                                {isOfficeFile ? (
                                  <Description style={{ fontSize: 50, color: 'red' }} />
                                ) : isPdf ? (
                                  <PictureAsPdf style={{ fontSize: 50, color: 'red' }} />
                                ) : isGoogleFormat ? (
                                  <Description style={{ fontSize: 50, color: 'red' }} />
                                ) : (
                                  <Description style={{ fontSize: 50, color: 'red' }} />
                                )}
                              </IconButton>
                            </Tooltip>
                            {isOfficeFile ? (
                              <iframe
                                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(attachment.file_url)}`}
                                title={fileName}
                                style={{ width: '240px', height: '240px', borderRadius: '4px' }}
                                frameBorder="0"
                              />
                            ) : isGoogleFile ? (
                              <iframe
                                src={`https://docs.google.com/gview?url=${encodeURIComponent(attachment.file_url)}&embedded=true`}
                                title={attachment.name}
                                style={{ width: '240px', height: '240px', borderRadius: '4px' }}
                                frameBorder="0"
                                sandbox="allow-scripts allow-same-origin"
                              />
                            ) : (
                              <iframe
                                src={attachment.file_url}
                                title={attachment.name}
                                style={{ width: '240px', height: '240px' }}
                                frameBorder="0"
                              />
                            )}
                            {designOrder ? (
                              ''
                            ) : (
                              <Typography>{attachment.name}</Typography>
                            )}
                          </>
                        );
                      })()}
                    </Box>
                    {/* {isAllAttachments || (details?.send_client_app_req == 1 && attachment?.isDesign == 1) || attachment?.approved == 1 ? ( */}
                    {isRefer || isAllAttachments || (details?.send_client_app_req == 1 && attachment?.isDesign == 1) ? (
                      ''
                    ) : (
                      <Box className={classes.checkboxContainer}>
                        <Checkbox
                          sx={{
                            cursor: 'pointer',
                            // color: 'black',
                            backgroundColor: theme.palette.grey.A700
                          }}
                          checked={
                            checkedItems.includes(attachment.ID) ? true : false
                          }
                          onChange={() => handleCheckboxChange(attachment.ID)}
                          color="primary"
                        />
                      </Box>
                    )}
                  </Box>
                )
                ) : null}
              </Grid>
            )
          })}
        </Grid>
        </>
      ) : (
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          py={15}
        >
          No {isRefer ? 'References' : isAllAttachments ? 'Attachments' : secTab == 'Designs' ? 'designs' : 'files'} found
        </Box>
      )}

      <Modal
        width={1000}
        open={openImageModal}
        handleClose={() => {
          setOpenImageModal(false)
        }}
        modalTitle={isRefer ? 'References' : isAllAttachments ? 'Attachments' : secTab == 'Designs' ? 'Designs' : 'Files'}
      >
        <Box display="flex" justifyContent="flex-end" mb={1}>
          <AttachmentDownloadIconButton
            file={
              currentImageIndex != null
                ? attachmentToFile(imageDesigns[currentImageIndex])
                : null
            }
            fileIndex={currentImageIndex ?? 0}
            hidden={!canDownloadFiles}
          />
        </Box>
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={handlePrevious}
            disabled={currentImageIndex === 0}
            sx={{
              opacity: currentImageIndex === 0 ? 0.3 : 1,
              pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
            }}
          >
            <Icon
              icon={arrowLeftOutlined}
              width={24}
              height={24}
              color="#006097"
            />
          </IconButton>

          <Box
            component={'div'}
            style={{
              width: '500px',
              height: '500px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            <img
              src={imageDesigns[currentImageIndex]?.file_url}
              alt={`Image ${currentImageIndex + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 8,
              }}
            />
          </Box>
          <IconButton
            onClick={handleNext}
            disabled={currentImageIndex === imageDesigns.length - 1}
            sx={{
              opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
              pointerEvents:
                currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
            }}
          >
            <Icon
              icon={arrowRightOutlined}
              width={24}
              height={24}
              color="#006097"
            />
          </IconButton>
        </div>
      </Modal>

      <AttachmentPreviewDialog
        open={open}
        onClose={() => {
          setOpen(false)
          setSelectedAttachment(null)
        }}
        fileUrl={selectedAttachment?.file_url}
        file={attachmentToFile(selectedAttachment)}
        isClient={isClient}
        userType={userType}
        pdfLoading={pdfLoading}
        setPdfLoading={setPdfLoading}
        useOfficeViewer={useOfficeViewer}
        setUseOfficeViewer={setUseOfficeViewer}
      />
      {selectedPDFForEdit && designOrder && (
        <PDFEditor
          open={openPDFEditor}
          onClose={() => {
            setOpenPDFEditor(false)
            setSelectedPDFForEdit(null)
          }}
          pdfUrl={selectedPDFForEdit.url}
          attachmentId={selectedPDFForEdit.item?.id || selectedPDFForEdit.item?.ID}
          requestId={details?.id ?? projectId}
          documentSource="design_order"
          onSaveSuccess={() => {
            setRefresh(!refresh)
            if (setFetchData) setFetchData(true)
          }}
        />
      )}
    </>
  )
}
